module.exports = __webpack_public_path__ + "static/media/github.0255bf2c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/social/github.svg
// module id = 27
// module chunks = 0